module.exports = __webpack_public_path__ + "static/media/check-icon2.0fcb5bbf.svg";